export default "__VITE_ASSET__6b63c3a6__"